<template>
  <div>
    <!-- 基本信息 -->
    <div class="basic-information">
      <div class="basic-information-title">基本信息</div>
<!--      <img :src="require('@/assets/img/redact.png')" class="redactImg" alt  v-if="showCC==true && hasModifyAuth"   @click="redact" srcset>-->
    </div>
    <!-- 基本信息列表 -->
    <div class="basic-information-flex">
      <ul class="basic-information-lists">
        <li>
          <div class="basic-information-lists-item">性别</div>
          <div class="basic-information-lists-text">{{data.custBasicInfo.sex==0?'男':data.custBasicInfo.sex==1?'女':''}}</div>
        </li>
        <li>
          <div class="basic-information-lists-item">生日</div>
          <div class="basic-information-lists-text">{{data.custBasicInfo.birthday}}</div>
        </li>
        <li>
          <div class="basic-information-lists-item">摄影主题</div>
          <div class="basic-information-lists-text">{{data.custBasicInfo.shootingTypeName}}</div>
        </li>
        <li>
          <div class="basic-information-lists-item">爱好</div>
          <div class="basic-information-lists-text">{{data.custBasicInfo.hobbyName}}</div>
        </li>
        <li>
          <div class="basic-information-lists-item">职业</div>
          <div class="basic-information-lists-text">{{data.custBasicInfo.occupationName}}</div>
        </li>
        <li>
          <div class="basic-information-lists-item">邮箱</div>
          <div class="basic-information-lists-text">{{data.custBasicInfo.email || ""}}</div>
        </li>
        <li>
          <div class="basic-information-lists-item">地区</div>
          <div class="basic-information-lists-text">{{data.custBasicInfo.provinceName}} {{data.custBasicInfo.cityName}}</div>
        </li>
        <li>
          <div class="basic-information-lists-item">地址</div>
          <div class="basic-information-lists-text">{{data.custBasicInfo.address}}</div>
        </li>
        <li>
          <div class="basic-information-lists-item">预估年龄</div>
          <div class="basic-information-lists-text">{{data.custBasicInfo.estimateAgeName}}</div>
        </li>
        <li>
          <div class="basic-information-lists-item">结婚纪念日</div>
          <div class="basic-information-lists-text">{{data.custBasicInfo.weddingDate}}</div>
        </li>
        <li>
          <div class="basic-information-lists-item">客户状态</div>
          <div class="basic-information-lists-text">{{data.custBasicInfo.Status}}</div>
        </li>
        <li>
          <div class="basic-information-lists-item">新/老客户分类</div>
          <div class="basic-information-lists-text">{{data.custBasicInfo.UNeworOldCustomer}}</div>
        </li>
        <li>
          <div class="basic-information-lists-item">限量款购买者</div>
          <div class="basic-information-lists-text">
            {{ data.custBasicInfo.limitedProdouctCustomer === 1 ? '是' : data.custBasicInfo.limitedProdouctCustomer === 0 ? '否' : '' }}
          </div>
        </li>
        <li>
          <div class="basic-information-lists-item">易手机用户</div>
          <div class="basic-information-lists-text">
            {{ data.custBasicInfo.SecondHandCustomer === 1 ? '是' : data.custBasicInfo.SecondHandCustomer === 0 ? '否' : '' }}
          </div>
        </li>

      </ul>
    </div>
    <!-- 备注 -->
    <div class="basic-remark" v-if="data.custBasicInfo.remark">
      <div class="basic-information-title">备注</div>
    </div>
    <div v-if="data.custBasicInfo.remark" class="remark-textarea">
           <textarea class="textarea" style="border: none;"  disabled="true" v-model="data.custBasicInfo.remark"  cols="30" rows="10"></textarea>
    </div>
    <!-- 相机 -->
    <!-- <div class="basic-remark" >
      <div class="basic-information-title">拥有其他相机</div>
       <img :src="require('@/assets/arrowsC.png')" :class="arrows==false?'arrowsC':'arrowsCs'" alt   @click="arrowsChange(arrows)"    srcset>
    </div> -->
    <!-- 相机列表 -->
    <div  :class="arrows==true?'camera-listActive':'camera-list'"    >
             <div class="camera-item" v-for="(item,index)  in  cameraListeD" v-bind:key="index" >
                    <img class="camera" :src="require('@/assets/img/camera.png')" alt>
                    <div> <span class="camera-brandName">{{item.brandName}}</span>  <span>{{item.assetModel}}</span></div>
             </div>
    </div>

    <!-- 弹框 修改基本信息 -->
    <div class="models-right">
      <van-popup
      v-model="basicShow"
      position="right"
      :overlay="true"
      :close-on-click-overlay="false"
      >
        <div class="basic-models">
          <div class="basic-models-list">
            <!-- 列表 -->
            <div class="basic-models-list-item soursName">
              <div class="models-list-item-title title1 must">姓名</div>
              <input v-model="pullList[0]['name']"  maxlength="100" placeholder="请输入用户名"/>
            </div>
            <!-- 性别选择 -->
            <div class="basic-models-list-item">
              <div class="models-list-item-title title1 must">性别</div>
              <!-- <van-field v-model="name" placeholder="请输入用户名"/> -->
              <div class="selectUp" @click="downSelections(0)">
                {{pullList[1]['name']||'请选择性别'}}
                <img
                  :src="require('@/assets/img/uparrow.png')"
                  class="uparrow"
                  alt
                  srcset
                >
              </div>
            </div>
            <!-- 时间选择 -->
            <div class="basic-models-list-item">
              <div class="models-list-item-title title1">生日</div>
              <!-- <van-field v-model="name" placeholder="请输入用户名"/> -->
              <div class="selectUp" @click="downTime(0)">
                {{pullList[2]['name']||'请选择'}}
                <img
                  :src="require('@/assets/img/uparrow.png')"
                  class="uparrow"
                  alt
                  srcset
                >
              </div>
            </div>
            <!-- 摄影主题 -->
            <div class="basic-models-list-itemS" :style="'border:none'">
              <div class="models-list-item-title title1">摄影主题</div>
              <!-- <van-field v-model="name" placeholder="请输入用户名"/> -->
              <div class="selectUp"></div>
            </div>
            <div class="basic-models-list-Checkbox">
              <van-checkbox
                class="list-Checkbox-item"
                checked-color="#E10000"
                v-for="(item,index) in  ShootingType "
                v-model="item.edit"
                v-bind:key="index"
                @change="checkboxCahnge(index,1)"
              >{{item.name}}</van-checkbox>
            </div>
            <div class="textareas-inputs">
              <div class="basic-models-list-itemS textareas" style="margin-left:0">
                <input type="text"  :disabled="ShootingTypeEdit"   v-model="pullList[3]['name']" placeholder="输入客户偏爱的摄影主题">
              </div>
            </div>
            <!-- 兴趣爱好 -->
            <div class="basic-models-list-itemS" :style="'border:none'">
              <div class="models-list-item-title title1">兴趣爱好</div>
              <!-- <van-field v-model="name" placeholder="请输入用户名"/> -->
              <div class="selectUp"></div>
            </div>
            <div class="basic-models-list-Checkbox">
              <van-checkbox
                class="list-Checkbox-item"
                checked-color="#E10000"
                v-for="(item,index) in  Hobby "
                v-model="item.edit"
                v-bind:key="index"
                @change="checkboxCahnge(index,2)"
              >{{item.name}}</van-checkbox>
            </div>
            <div class="textareas-inputs">
              <div class="basic-models-list-itemS textareas" style="margin-left:0">
                <input type="text"    :disabled="HobbyEdit"   v-model="pullList[4]['name']" placeholder="输入客户偏爱的兴趣爱好">
              </div>
            </div>
            <!-- 职业 -->
            <div class="basic-models-list-item">
              <div class="models-list-item-title title1">职业</div>
              <!-- <van-field v-model="name" placeholder="请输入用户名"/> -->
              <div class="selectUp" @click="downSelections(1)">
                {{pullList[5]['name']||'选择职业'}}
                <img
                  :src="require('@/assets/img/uparrow.png')"
                  class="uparrow"
                  alt
                  srcset
                >
              </div>
            </div>
            <!-- 结婚纪念日 -->
            <div class="basic-models-list-item">
              <div class="models-list-item-title title1">结婚纪念日</div>
              <!-- <van-field v-model="name" placeholder="请输入用户名"/> -->
              <div class="selectUp" @click="downTime(1)">
                {{pullList[6]['name']||'请选择'}}
                <img
                  :src="require('@/assets/img/uparrow.png')"
                  class="uparrow"
                  alt
                  srcset
                >
              </div>
            </div>
            <div class="basic-models-list-item soursName">
              <div class="models-list-item-title title1">邮箱</div>
              <input v-model="obj.email"  maxlength="100" placeholder="请输入邮箱"/>
            </div>

            <!-- 地区 -->
            <div class="basic-models-list-item">
              <div class="models-list-item-title title1">地区</div>
              <!-- <van-field v-model="name" placeholder="请输入用户名"/> -->
              <div class="region" @click="downSelections(11)">
                {{province.name||'请选择'}}
                <img :src="require('@/assets/img/uparrow.png')" class="uparrow" alt srcset>
              </div>
              <div class="region" @click="province.name?downSelections(12):''">
                {{city.name||'请选择'}}
                <img :src="require('@/assets/img/uparrow.png')" class="uparrow" alt srcset>
              </div>
              <!-- <div class="region" @click="downSelections(13)">
                {{district.name||'请选择-区'}}
                <img :src="require('@/assets/img/uparrow.png')" class="uparrow" alt srcset>
              </div> -->
            </div>
            <!--  详细地址  -->
            <div class="basic-models-list-item">
              <div class="models-list-item-title title1">地址</div>
              <div class="selectUp">
                <input type="text"   maxlength="25"  v-model="pullList[7]['name']" placeholder="请输入详细地址">
              </div>
            </div>
            <!-- 预估年龄 -->
            <div class="basic-models-list-item">
              <div class="models-list-item-title title1 must">预估年龄</div>
              <div class="selectUp" @click="downSelections(2)">
                {{pullList[8]['name']||'选择预估年龄'}}
                <img
                  :src="require('@/assets/img/uparrow.png')"
                  class="uparrow"
                  alt
                  srcset
                >
              </div>
            </div>
            <!-- 备注 -->
            <div class="basic-models-list-item">
              <div class="models-list-item-title title1">备注</div>
              <div class="selectUp">
                <!-- <input type="textarea"  "> -->
                <textarea v-model="pullList[9]['name']"  maxlength="1024" placeholder="请输入备注信息" cols="30" rows="10"></textarea>
              </div>
            </div>
            <!-- 拥有其它相机 -->
            <div class="basic-models-list-itemS">
              <div class="models-list-item-title title1" :style="'width:3rem'">拥有其它相机</div>
              <div class="selectUp"></div>
            </div>

            <!-- 添加相机 -->
            <div class="addCamera" v-for="(item,index)  in  cameraList"  v-bind:key="index">
              <div class="camera-delete">
                <div>No.{{index+1}}</div>
                <img class="delete" :src="require('@/assets/img/delete.png')"  @click="deleteCamera(index)" alt>
              </div>

              <div class="camera-flex"  >
                <div class="camera-name title1">品牌</div>
                <div class="camera-selectUp" @click="downSelections(3,index)">
                  {{item.name||'请选择品牌'}}
                  <img
                    :src="require('@/assets/img/uparrow.png')"
                    class="uparrow"
                    alt
                    srcset
                  >
                </div>
              </div>

              <div class="camera-flex">
                <div class="camera-name title1">型号</div>
                <div class="camera-selectUp">
                  <input type="text" class="camera-selectUpInput" v-model="item.model"  placeholder="请输入相机型号">
                </div>
              </div>
            </div>

            <div class="add-button" v-if="showCC==true"  @click="addCamera" >＋添加相机</div>
          </div>
          <!-- 确定取消 -->
          <div class="position-bottom-button">
            <div class="confirm-cancel">
              <div class="button-flex-color flex-border-button">
                <div class="button-flex-item" @click="cancelBasic">取消</div>
              </div>
              <div class="button-flex-color">
                <div class="button-flex-item button-active" @click="confirmBasic">确定</div>
              </div>
            </div>
          </div>
        </div>
      </van-popup>
    </div>

    <!-- 时间筛选 -->
    <van-popup v-model="timeShow" position="bottom" :overlay="true" style="width:100%">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        @confirm="timeConfirm"
        @cancel="timeCancel"
        @change="timeChange"
        :min-date="minDate"
        :max-date="maxDate"
      />
    </van-popup>

    <!-- 下拉筛选 -->
    <van-popup v-model="showDownSelection" position="bottom" :overlay="true">
      <van-picker
        show-toolbar
        title
        :columns="downSelection"
        @cancel="onCancelCode"
        @confirm="onConfirmCode"
        value-key="name"
        class="van-picker-li"
      />
    </van-popup>
  </div>
</template>

<script>

  import $ from 'jquery';

export default {
  name: "",
  props: {
    // 在该视图上的高度
    data: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      basicShow: false, // 编辑展示
      name: "",
      obj : {

      },//客户基本信息
      currentDate: new Date(this.$D.getFullYear(),this.$D.getMonth(),this.$D.getDate()), // 时间
      minDate: new Date(this.$D.getFullYear()-100,this.$D.getMonth(),this.$D.getDate()), // 最小时间
      maxDate: new Date(this.$D.getFullYear(),this.$D.getMonth(),this.$D.getDate()),
      timeShow: false, // 时间展示
      showDownSelection: false, // 展示下拉菜单
      downSelection: ["1", "2"], // 下拉列表
      pullList: [
        {name:"",val:""},  //姓名
        {name:"",val:""},  //性别
        {name:"",val:""},  //生日
        {name:"",val:""},  //输入摄像主题
        {name:"",val:""},  //输入其它爱好
        {name:"",val:""},  //职业
        {name:"",val:""},  //结婚纪念日
        {name:"",val:""},  //详细地址
        {name:"",val:""},  //预估年龄
        {name:"",val:""},  //备注
      ],
      // 字典表查询code
      codeList:['SEX','ShootingType','Hobby','Occupation','EstimateAge','Brand'],
      SEX:[],// 性别
      ShootingType:[], // 摄影主题
      Hobby:[], // 爱好
      Occupation:[], // 职业
      EstimateAge:[], // 预估年龄
      Brand:[],//其他相机品牌
      upSelectCode:0,
      upSelectTime:0,
      cameraListeD:[] ,  //相机数组列表
      cameraList:[] ,  //相机数组列表
      cameraIndex:0,  // 当前选择相机索引
      ShootingTypeEdit:true,
      HobbyEdit:true,
      province:{name:"",id:""}, // 省
      city:{name:"",id:""}, // 市
      district:{name:"",id:""}, // 区县
      Locals:0,  //默认当前选择 省
      custId:"", //客户ID
      cameraListDelete:[], // 删除相机集合
      showCC:true,
      arrows:true,       // 默认箭头打开
      hasModifyAuth : true //是否有修改权限
    };
  },
  methods: {
    /**
     *
     *  编辑
     *
     */
    redact() {
        this.basicShow = true;
        this.cameraListDelete=[];
        this.getCustId(this.$parent.$parent.custId);
    },

    /**
     *
     *  下拉菜单点击
     *
     */
    downSelections(val,index) {
      this.upSelectCode=val;
      if(val==3){
         this.cameraIndex=index;
      }
      if(val>=0&&val<11){
      switch(val){
        case 0      :  this.downSelection=this.SEX ;  break
        case 1      :  this.downSelection=this.Occupation; break
        case 2      :  this.downSelection=this.EstimateAge; break
        case 3      :  this.downSelection=this.Brand; break
      }
      this.showDownSelection = true;
      }
      if(val==11){
        this.getLocals(1);
        this.Locals=0;
      }
      if(val==12){
        this.getLocals('',this.province.id);
        this.Locals=1;
      }
      if(val==13){
        this.getLocals('',this.city.id);
        this.Locals=2;
      }
    },

    /**
     *
     * 确定 取消 按钮
     *
     */
    cancelBasic() {
      let $data=this.pullList;
      let $hobby=this.Hobby;
      let $shootingType=this.ShootingType;
      for(let i=0;i<$data.length;i++){
           $data[i]['name']="";
           $data[i]['val']=""
      }
      for(let h=0;h<$hobby.length;h++){
          $hobby[h]['edit']=false
      }
      for(let s=0;s<$shootingType.length;s++){
          $shootingType[s]['edit']=false
      }
      this.Hobby=$hobby;
      this.ShootingType=$shootingType;
      this.pullList=$data;
      this.basicShow = false;
      this.obj = {};
    },
    /**
     *  @param {String}  custName      客户名称
     *  @param {String}  gender        性别
     *  @param {String}  birthday	     生日
     *  @param {String}  shootingType  摄影主题   多个选项,英文半角逗号分隔
     *  @param {String}  shootingTypeOther   其他摄影主题
     *  @param {String}  hobby               兴趣爱好   多个选项,英文半角逗号分隔
     *  @param {String}  hobbyOther          其他兴趣爱好
     *  @param {String}  occupation          职业
     *  @param {String}  weddingDate         结婚纪念日
     *  @param {String}  province            省
     *  @param {String}  city                城市
     *  @param {String}  estimateAge         预估年龄
     *  @param {String}  remark              备注
     *
     */
    confirmBasic() {
      let data = $.extend(true,{},this.obj,{
        custId:this.$parent.$parent.custId,
        salesId:this.$wxuserUtil.getUserId(),
        custName:this.pullList[0]['name'],
        gender:this.pullList[1]['val'],
        birthday:this.pullList[2]['name'],
        shootingType:"",
        shootingTypeOther:this.pullList[3]['name'],
        hobby:"",
        hobbyOther:this.pullList[4]['name'],
        occupation:this.pullList[5]['val'],
        weddingDate:this.pullList[6]['name'],
        estimateAge:this.pullList[8]['val'],
        address:this.pullList[7]['name'],
        remark:this.pullList[9]['name'],
        province:this.province.id,
        city:this.city.id,
        updAssetJsonStr:null,
        delAssetJsonStr:null
      });


        let $data=[];
        if(this.cameraList.length>0){
        for(let i=0;i<this.cameraList.length;i++){
               if(this.cameraList[i]['val']){
                 $data.push({
                   assetId: this.cameraList[i]['assetId'],
                   model: this.cameraList[i]['model'],
                   brand: this.cameraList[i]['val']
                 })
               }
        }
        }else{
          $data='';
        }

        let $delete=[]
        if(this.cameraListDelete.length>0){
        for(let o=0;o<this.cameraListDelete.length;o++){
            if(this.cameraListDelete[o]['assetId']){
              $delete.push({assetId:this.cameraListDelete[o]['assetId']})
            }
        }
        }else{
           $delete='';
        }

        // 循环判断相机列表
        for(let m=0;m<$data.length;m++){
             console.log("相机列表数据",$data[m])
             if($data[m]['brand']==""){
                this.$title("请完善相机品牌");
                return;
             }
             if($data[m]['model']==""){
                console.log("型号等于空")
                this.$title("请完善相机型号");
                return;
             }
             if($data[m]['model']==""&&$data[m]['brand']==""){
                console.log("型号等于空")
                this.$title("请完善相机型号与品牌");
                return;
             }
        }

        data['updAssetJsonStr']=JSON.stringify($data.length>0?$data:[]);
        data['delAssetJsonStr']=JSON.stringify($delete.length>0?$delete:[]);
        data['hobby']=this.strJoin(this.Hobby).join(";")
        data['shootingType']=this.strJoin(this.ShootingType).join(";")
        if(data['custName']==''){
          this.$title("请输入姓名");
          return;
        }
        // if(data['gender']==''){
        //   this.$title("请选择性别");
        //   return;
        // }

        // if(data['birthday']==''){
        //   this.$title("请选择生日日期");
        //   return;
        // }
        // if(data['shootingType']==''){
        //   this.$title("请选择摄影主题");
        //   return;
        // }
        if(this.ShootingType[this.ShootingType.length-1]['edit']==true){
          if(data['shootingTypeOther']==""){
            this.$title("输入客户偏爱的摄影主题");
            return;
          }
        }
        // if(data['hobby']==''){
        //   this.$title("请选择兴趣爱好");
        //   return;
        // }
        if(this.Hobby[this.Hobby.length-1]['edit']==true){
           if(data['hobbyOther']==""){
            this.$title("输入客户偏爱的兴趣爱好");
            return;
          }
        }
        // if(data['occupation']==''){
        //   this.$title("请选择职业");
        //   return;
        // }
        // if(data['address']==''){
        //   this.$title("请选择输入详情地址");
        //   return;
        // }
        if(data['estimateAge']==''){
          this.$title("请选择预估年龄");
          return;
        }

        // console.log("修改提交数据",data)
        // return;

        this.$api.saveCusetNews(data).then(Response=>{
              if(Response.success){
                   this.$title("修改成功");
                   setTimeout(() => {
                   this.basicShow=false;
                   this.$title("").clear();
                   this.updateCusts();
                   this.cancelBasic();
                   }, 500);
              }else{
                    this.$title(Response.msg);
              }
        }).catch(err=>{
                    this.$title("接口异常");
        })
    },
    strJoin(data){
      let $data=[];
      if(Array.isArray(data)){
        for(let i=0;i<data.length;i++){
            if(data[i]['edit']==true){
              $data.push(data[i]['value'])
            }
        }
        return $data;
      }else{
        return [];
      }
    },

    /**
     *
     * 时间上拉选择
     *
     */
    downTime(val) {
      if(val>=0){
                this.upSelectTime=val;
                this.timeShow=true;
      }
    },
    timeConfirm(val) {
      var date_value = this.$time(val)
       if(val){
        switch(this.upSelectTime){
           case  0    :    this.setUpSelectCode(2,2,date_value);break
           case  1    :    this.setUpSelectCode(2,6,date_value);break
        }
       }
    },
    timeCancel() {
       this.timeShow = false;
    },
    timeChange() {},
    /**
     *
     * 下拉菜单
     *
     */
    onCancelCode() {
      this.showDownSelection=false;
    },
    onConfirmCode(val) {
      if(val){
      if(this.upSelectCode<11){
      switch(this.upSelectCode){
           case  0    :    this.setUpSelectCode(1,1,val);break
           case  1    :    this.setUpSelectCode(1,5,val);break
           case  2    :    this.setUpSelectCode(1,8,val);break
           case  3    :    this.setUpSelectCode(3,this.cameraIndex,val);break
      }}else{
         if(this.Locals==0){
            this.province['name']=val.name;
            this.province['id']=val.id;
         }else
         if(this.Locals==1){
            this.city['name']=val.name;
            this.city['id']=val.id;
         }else
         if(this.Locals==2){
            this.district['name']=val.name;
            this.district['id']=val.id;
         }
          this.showDownSelection = false;
      }}
    },
    setUpSelectCode(ID,index,value){
       if(ID==1){
           this.pullList[index]['name']=value.name;
           this.pullList[index]['val']=value.value;
           this.showDownSelection = false;
       }
      if(ID==2){
           this.pullList[index]['name']=value;
           this.pullList[index]['val']='';
           this.timeShow = false;
      }
      if(ID==3){
           this.cameraList[index]['name']=value.name;
           this.cameraList[index]['brandName']=value.name;
           this.cameraList[index]['val']=value.value;
           this.cameraList[index]['brand']=value.value;
           this.showDownSelection = false;
      }
    },
    /**
     *
     *  添加相机
     *
     */
    addCamera(){
      // assetId ：主键ID，为空则为新增一条相机品牌数据
      // model ： 相机型号
      // brand ：  相机品牌
       this.cameraList.push({assetId:"",brand:"",val:"",model:"",edit:false,name:"",brandName:"",assetModel:""})
    },
    deleteCamera(index){
       this.cameraListDelete.push(this.cameraList[index])
       this.cameraList.splice(index,1)
    },
    /**
     *
     * 字典查询
     *
     */
    getQueryByTcode(){
      for(let i=0;i<this.codeList.length;i++){
      this.$api.getQueryByTcode({tcode:this.codeList[i]}).then(Response=>{
          switch(this.codeList[i]){
                case 'SEX'           :this.SEX=Response.data; break
                case 'ShootingType'  :this.ShootingType=this.setjudge(1,Response.data); break
                case 'Hobby'         :this.Hobby=this.setjudge(2,Response.data); break
                case 'Occupation'    :this.Occupation=Response.data; break
                case 'EstimateAge'   :this.EstimateAge=this.setCodeAlls(Response.data); break
                case 'Brand'         :this.Brand=Response.data; break
          }
      })
      }
    },
    /**
     *
     *  区域查询
     *
     */
    getLocals(ID,pid){
      this.$api.getLocals({pid:ID?'':pid}).then(Response=>{
           this.downSelection=Response.data;
           this.showDownSelection=true;
      })
    },
    setjudge(ID,Data){
      if(Array.isArray(Data)){
       for(let i=0;i<Data.length;i++){
          Data[i]['edit']=false
       }
       return Data;
    }
    },
    checkboxCahnge(val,ID){
      if(ID==1){
        if(this.ShootingType[this.ShootingType.length-1]['edit']==true){
              this.ShootingTypeEdit=false;
        }else{
              this.ShootingTypeEdit=true;
              this.pullList[3]['name']="";
        }
      }else{
        if(this.Hobby[this.Hobby.length-1]['edit']==true){
              this.HobbyEdit=false;
        }else{
              this.HobbyEdit=true;
              this.pullList[4]['name']="";
        }
      }

    },
    updateCusts(){
         this.$api.getCustDetail({salesId:this.$wxuserUtil.getUserId(),custId:this.$parent.$parent.custId}).then(Response=>{
                 console.log("更新用户",Response)
                 if(Response.success){
              let $detal    =     Response.data.custBasicInfo;
              let $data=Response.data.assetList||[];
              this.data.custBasicInfo= $detal;
              this.obj = $detal;
              let $pL=[];$pL=this.pullList;
              $pL[0]['name']=$detal['custName'];
              $pL[0]['val']=$detal['custName'];
              $pL[1]['name']=$detal['sexName'];
              $pL[1]['val']=$detal['sex'];
              $pL[2]['name']=$detal['birthday'];
              $pL[2]['val']=$detal['birthday'];
              $pL[3]['name']=$detal['shootingTypeOther'];   //摄影主题其他
              $pL[4]['name']=$detal['hobbyOther'];    //爱好其它
              $pL[5]['name']=$detal['occupationName'];
              $pL[5]['val']=$detal['occupation'];
              $pL[6]['name']=$detal['weddingDate'];
              $pL[6]['val']=$detal['weddingDate'];
              $pL[7]['name']=$detal['address'];
              $pL[7]['val']=$detal['address'];
              $pL[8]['name']=$detal['estimateAgeName'];
              $pL[8]['val']=$detal['estimateAge'];
              $pL[9]['name']=$detal['remark'];
              $pL[9]['val']=$detal['remark'];
              this.pullList=$pL;
              for(let i=0;i<$data.length;i++){
                    $data[i]['name']     = $data[i]['brandName']||''
                    $data[i]['assetId']  = $data[i]['id']||''
                    $data[i]['model']    = $data[i]['assetModel']||''
                    $data[i]['brand']    = $data[i]['brand']||''
                    $data[i]['val']      = $data[i]['brand']||''
                    $data[i]['edit']     = false
                }
            this.cameraList =$data||[]; //相机列表
            this.cameraListeD=$data||[]; //相机列表
          }
         })
    },
    getCustId(custId){
      this.$api.getCustDetail({salesId:this.$wxuserUtil.getUserId(),custId:custId}).then(Response=>{
          if(Response.success==true){
            console.log("打开详情信息",Response)
            let $data=Response.data.assetList||[];
            let $detal=Response.data.custBasicInfo||{};
            this.obj = $detal;
            let $HB_ = $detal.hobby?$detal.hobby.split(";"):'';  //获取爱好value值
            let $SP_ = $detal.shootingType?$detal.shootingType.split(";"):''; //获取摄影value值
            let $pL   =[],$HB=[],$SP=[];$pL=this.pullList;$HB=this.Hobby;$SP=this.ShootingType;
            console.log("爱好***",$HB_);
            console.log("摄影***",$SP_)
          for(let H=0;H<$HB_.length;H++){
              for(let h1=0;h1<$HB.length;h1++){
                  if($HB_[H]==$HB[h1]['value']){
                    $HB[h1]['edit']=true;
                  }
              }
          }
          for(let S=0;S<$SP_.length;S++){
              for(let h2=0;h2<$SP.length;h2++){
                  if($SP_[S]==$SP[h2]['value']){
                     $SP[h2]['edit']=true;
                  }
              }
          }

          this.Hobby=$HB;
          this.ShootingType=$SP;
          for(let i=0;i<$data.length;i++){
                $data[i]['name']     = $data[i]['brandName']||''
                $data[i]['assetId']  = $data[i]['id']||''
                $data[i]['model']    = $data[i]['assetModel']||''
                $data[i]['brand']    = $data[i]['brand']||''
                $data[i]['val']      = $data[i]['brand']||''
                $data[i]['edit']     = false
            }
              $pL[0]['name']=$detal['custName'];
              $pL[0]['val']=$detal['custName'];
              $pL[1]['name']=$detal['sexName'];
              $pL[1]['val']=$detal['sex'];
              $pL[2]['name']=$detal['birthday'];
              $pL[2]['val']=$detal['birthday'];
              $pL[3]['name']=$detal['shootingTypeOther'];   //摄影主题其他
              $pL[4]['name']=$detal['hobbyOther'];    //爱好其它
              $pL[5]['name']=$detal['occupationName'];
              $pL[5]['val']=$detal['occupation'];
              $pL[6]['name']=$detal['weddingDate'];
              $pL[6]['val']=$detal['weddingDate'];
              $pL[7]['name']=$detal['address'];
              $pL[7]['val']=$detal['address'];
              $pL[8]['name']=$detal['estimateAgeName'];
              $pL[8]['val']=$detal['estimateAge'];
              $pL[9]['name']=$detal['remark'];
              $pL[9]['val']=$detal['remark'];

            this.province['name']= $detal.provinceName;
            this.province['id']= $detal.province;
            this.city['name']= $detal.cityName;
            this.city['id']= $detal.city;
            this.cameraList =$data||[]; //相机列表
            this.cameraListeD=$data||[]; //相机列表
            this.pullList=$pL;
            console.log("改变后的数组",$pL)
            console.log("地区",this.province,this.city)
          }
      })
    },
    setCodeAlls(data){
      if(Array.isArray(data)){
        for(let i=0;i<data.length;i++){
          data[i]['value']=data[i]['value']
        }
        return data;
      }else{
        return  [];
      }
   },
   authority(Bl){
   this.showCC=Bl;
   },
  arrowsChange(val){
     console.log(val)
     if(val){
       this.arrows=false;
     }else{
       this.arrows=true;
     }
  }
  },
  mounted(){
    //debugger;
    //this.hasModifyAuth = this.$wxuserUtil.hasFunAuthByRouteInst(this.$route,this.$funcKey.BasicModified);
    console.log("基础页面判断hasModifyAuth",this.hasModifyAuth);
    this.getQueryByTcode()
  }
};
</script>
<style lang="less" scoped>
.camera-list{
    transition: height .5s;
    -moz-transition: height .5s;	/* Firefox 4 */
    -webkit-transition: height .5s;	/* Safari 和 Chrome */
    -o-transition: height .5s;	/* Opera */
    padding: .3rem .5rem;
    display: flex;
    flex-direction: column;
    min-height:.0rem;
    overflow: hidden;
    .camera-item{
      height:1rem;
      line-height: 1rem;
      -ms-flex-item-align: center;
      align-items: center;
      margin-top: .1rem;
      display: flex;
      flex-direction: row;
      background: #F6F6F6;
      padding: 0 .3rem;
      font-size: .35rem;
      color:#2A2A2A;
      font-weight: 600;
      .camera-brandName{
        padding: 0rem .3rem;
      }
    }
    .camera{
      width:.5rem;
      height: .4rem;
    }
}
.camera-listActive{
    transition: height .5s;
    -moz-transition: height .5s;	/* Firefox 4 */
    -webkit-transition: height .5s;	/* Safari 和 Chrome */
    -o-transition: height .5s;	/* Opera */
    padding: 0;
    display: flex;
    flex-direction: column;
    height:0;
    overflow: hidden;
}
.remark-textarea{
  padding: .3rem .5rem;
  .textarea{
    background: #ffffff;
    width:100%;
    height:2rem;
  }
}
.add-button {
  height: 1rem;
  line-height: 1rem;
  text-align: center;
  font-weight: bold;
  color: rgba(225, 9, 19, 1);
  margin: 0.5rem 0.3rem 0.8rem 0.8rem;
  background: #fff5f5;
  border: 1px solid rgba(242, 182, 185, 1);
  border-radius: 0.1rem;
}
.addCamera {
  display: flex;
  flex-direction: column;
  margin-left: 0.8rem;
  border: 1px dashed rgba(229, 229, 229, 1);
  margin-right: 0.3rem;
  .camera-delete {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    height: 1rem;
    -ms-flex-item-align: center;
    align-items: center;
    padding: 0 0.3rem;
    .delete {
      width: 0.3rem;
      height: 0.3rem;
    }
  }
  .camera-flex {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    height: 1rem;
    line-height: 1rem;
    -ms-flex-item-align: center;
    align-items: center;
    margin: 0 0.3rem 0.3rem 0.3rem;
    background: #f2f2f2;

    .camera-name {
      width: 1.5rem;
      height: 1rem;
      line-break: 1rem;
      text-align: center;
    }

    .camera-selectUp {
      width: 5rem;
      height: 1rem;
      -ms-flex-item-align: center;
      align-items: center;
      position: relative;
      .uparrow {
        position: absolute;
        right: 0.2rem;
        top: 50%;
        width: 0.3rem;
        height: 0.3rem;
        margin-top: -0.15rem;
      }
      .camera-selectUpInput {
        width: 4.8rem;
        height: 1rem;
        border: none;
        outline: none;
        background: #f2f2f2;
      }
    }
  }
}
.selectUp {
  text-align: center;
  border: 0;
  margin: 0;
  padding: 0;
  width: 100%;
  resize: none;
  display: block;
  color: #323233;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  background-color: transparent;
  .uparrow {
    position: absolute;
    right: 0.2rem;
    top: 50%;
    width: 0.3rem;
    height: 0.3rem;
    margin-top: -0.15rem;
  }
  input {
    border: none;
    outline: none;
    text-align: center;
  }
  textarea{
    border: none;
    outline: none;
    height:0.8rem;
    width:4rem;
  }
}

.basic-models-list {
  height: 92%;
  font-size: 0.35rem;
  overflow-x: auto;
  margin-bottom: 0rem;
  .basic-models-list-item,
  .basic-models-list-itemS {
    margin-left: 0.8rem;
    height: 1.2rem;
    -ms-flex-item-align: center;
    align-items: center;
    display: flex;
    flex-direction: row;
    // justify-content: space-between;
    position: relative;
    .van-field__control{
      font-size: .35rem;
    }
  }
    .soursName{

    input{
      width:100%;
      border:none;
      outline: none;
      text-align: center;
    }
    }

  .basic-models-list-Checkbox {
    margin-left: 0.3rem;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    .list-Checkbox-item {
      margin-left: 0.5rem;
      margin-top: 0.4rem;
    }
    .van-checkbox__label {
      margin-left: 5px;
    }
  }
  .textareas-inputs {
    margin-left: 0.8rem;
    padding-bottom: 0.4rem;
    position: relative;
    .textareas {
      margin-top: 0.3rem;
      width: 90%;
      background: #f6f6f6;
      .van-field__control,
      .van-field__body,
      input {
        background: #f6f6f6;
        border: none;
        outline: none;
        padding-left: 0.3rem;
        width: 7rem;
      }
    }
  }
  .textareas-inputs:after {
    content: "  ";
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 1px;
    background-color: #b3b8c3;
    /* 如果不用 background-color, 使用 border-top:1px solid #f00; 效果是一样的*/
    -webkit-transform: scaleY(0.15);
    transform: scaleY(0.15);
  }

  .basic-models-list-item:after {
    content: "  ";
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 1px;
    background-color: #b3b8c3;
    /* 如果不用 background-color, 使用 border-top:1px solid #f00; 效果是一样的*/
    -webkit-transform: scaleY(0.15);
    transform: scaleY(0.15);
  }
  .van-cell {
    padding: 0rem;
  }
  .models-list-item-title {
    width: 2.5rem;
  }
  .region {
    width: 4rem;
    position: relative;
    height: 1.2rem;
    line-height: 1.2rem;
    -ms-flex-item-align: center;
    align-items: center;
    padding-left: 0.3rem;
    // border-right: 1px  solid  #b3b8c3;
    .uparrow {
      position: absolute;
      right: 0.2rem;
      top: 50%;
      width: 0.3rem;
      height: 0.3rem;
      margin-top: -0.15rem;
    }
  }
}
.position-bottom-button {
  // position: fixed;
  // bottom: 0rem;
  // margin-top: .8rem;
  width: 100%;
  .confirm-cancel {
    width: 100%;
    height: 1.4rem;
    border-top: 1px solid #b3b8c3;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    .button-flex-color {
      width: 50%;
      height: 1.4rem;
      text-align: center;
      .button-flex-item {
        width: 100%;
        height: 100%;
        text-align: center;
        line-height: 1.4rem;
        font-size: 0.4rem;
        background: #222222;
        color: #fff;
      }
      .button-active {
        background: #e51c23;
        color: #fff;
      }
    }
    .flex-border-button {
      // border-right: 1px solid #a4abba;
    }
  }
}
.models-right {
  .van-popup {
    height: 100%;
  }
}
.basic-models {
  width: 9.5rem;
  background: #fff;
  position: relative;
  height: 100%;
}
.basic-information {
  // width:100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  -ms-flex-item-align: center;
  align-items: center;
  height: 1rem;
  padding: 0.3rem 0.5rem 0rem 0.5rem;
  border-top: 0.1rem solid rgb(244, 244, 244);
  .redactImg {
    width: 0.4rem;
    height: 0.4rem;
  }
}
.basic-remark {
  height: 1rem;
  padding: 0.3rem 0.5rem 0rem 0.5rem;
  border-top: 0.1rem solid rgb(244, 244, 244);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  -ms-flex-item-align: center;
  align-items: center;
}
.basic-information-flex {
  padding: 0.3rem 0.5rem;
  .basic-information-lists {
    li {
            display: flex;
            //    justify-content: space-between;
            -ms-flex-item-align: center;
            align-items: center;
            min-height: 0.8rem;
            word-break: break-all;
    /* word-wrap: break-word; */
            -webkit-line-clamp: 2;
            white-space:normal;
            text-overflow: ellipsis;
    }
    .basic-information-lists-item {
      width: 3.5rem;
      color: #7e7e7e;
      font-size: 0.35rem;
    }
    .basic-information-lists-text {
      font-size: 0.35rem;
      color: #4d4d4d;
      width:6rem;
    }
  }
}

.basic-information-title {
  position: relative;
  color: #2a2a2a;
  font-size: 0.4rem;
  font-weight: 600;
}
.basic-information-title::after {
  content: "";
  width: 0.1rem;
  height: 0.35rem;
  position: absolute;
  left: -0.2rem;
  top: 0.12rem;
  background-color: #e10913;
}
.arrowsC{
  width:.4rem;
  height:.4rem;
  transform-origin:center center; //旋转中心要是正中间 才行
  transform:rotate(180deg);
  -ms-transform:rotate(180deg); 	/* IE 9 */
  -moz-transform:rotate(180deg); 	/* Firefox */
  -webkit-transform:rotate(180deg); /* Safari 和 Chrome */
  -o-transform:rotate(180deg); 	/* Opera */

}

.arrowsCs{
  width:.4rem;
  height:.4rem;
  transform-origin:center center; //旋转中心要是正中间 才行
  transform:rotate(0deg);
  -ms-transform:rotate(0deg); 	/* IE 9 */
  -moz-transform:rotate(0deg); 	/* Firefox */
  -webkit-transform:rotate(0deg); /* Safari 和 Chrome */
  -o-transform:rotate(0deg); 	/* Opera */

}

.must::before{
    content: '*';
    position: absolute;
    left: -.3rem;
    font-size: 14px;
    color: #f44;
}

</style>



// WEBPACK FOOTER //
// src/components/client/childCompoents/basicInfo360.vue